import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import { Observable, defer, from, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

export type AuthDeviceContext = {
    deviceId: string | null;
    deviceModel: string | null;
    osVersion: string | null;
};

@Injectable({
    providedIn: 'root'
})
export class CapacitorDeviceService {
    private readonly authDeviceContext$: Observable<AuthDeviceContext> = defer(() =>
        from(Promise.all([Device.getInfo(), Device.getId()]))
    ).pipe(
        map(([deviceInfo, deviceId]) => {
            return {
                deviceId: deviceId?.identifier ?? null,
                deviceModel: deviceInfo?.model ?? null,
                osVersion: deviceInfo?.osVersion ?? null
            };
        }),
        catchError(() => of({ deviceId: null, deviceModel: null, osVersion: null })),
        shareReplay(1)
    );

    getAuthDeviceContext(): Observable<AuthDeviceContext> {
        return this.authDeviceContext$;
    }
}
